function formatMoney(cents) {
  return theme && typeof theme.money_format_with_code_preference !== 'undefined'
    ? theme.Shopify.formatMoney(cents, theme.money_format_with_code_preference)
    : '$ ' + (cents / 100).toLocaleString('en-USD') + '.00';
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  drawer.classList.remove('hidden');
  drawer.classList.add('open');
  fetchCart();
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  drawer.classList.remove('open');
  drawer.classList.add('hidden');
}

function fetchCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      const itemsContainer = document.getElementById('cart-items');
      itemsContainer.innerHTML = '';
      data.items.forEach(item => {
        const options = item.options_with_values.map(opt => `${opt.name}: ${opt.value}`).join('<br>');
        const itemEl = document.createElement('div');
        itemEl.className = 'cart-item';
        itemEl.innerHTML = `
          <img src="${item.image}" alt="${item.title}" />
          <div class="cart-details">
            <strong>${item.product_title}</strong><br>
            ${formatMoney(item.price)}<br>
            ${options}<br>
            <div class="cart-actions">
              <button class="qty-btn" onclick="updateQuantity('${item.key}', ${item.quantity - 1})"><svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title></title>
    <path d="M0 0H8V1H0V0Z" fill="currentColor"></path>
  </svg></button>
              <span>${item.quantity}</span>
              <button class="qty-btn" onclick="updateQuantity('${item.key}', ${item.quantity + 1})"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title></title>
    <path d="M4.60125 0V3.44355H8V4.53226H4.60125V8H3.38205V4.53226H0V3.44355H3.38205V0H4.60125Z" fill="currentColor"></path>
  </svg></button>
              <span class="cart-remove" onclick="removeCartItem('${item.key}')">Remove</span>
            </div>
          </div>
        `;
        itemsContainer.appendChild(itemEl);
      });
      document.getElementById('cart-total').innerText = formatMoney(data.total_price);

      if (data.item_count === 0) {
        itemsContainer.innerHTML = `
          <div style="text-align:center;margin-top:40px;">
            <p>Your cart is empty.</p>
            <a href="/collections/shop-all" style="text-decoration:underline;color:black;">Explore the latest arrivals.</a>
          </div>
        `;
        document.getElementById('cart-footer').style.display = 'none';
      } else {
        document.getElementById('cart-footer').style.display = 'flex';
      }
    });
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(fetchCart);
}

function updateQuantity(key, qty) {
  if (qty < 1) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(fetchCart);
}

window.addEventListener('DOMContentLoaded', () => {
  fetchCart();
  document.getElementById('cart-close').addEventListener('click', closeCartDrawer);

  document.querySelector('.cart-drawer-overlay').addEventListener('click', closeCartDrawer);

  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(() => openCartDrawer());
    });
  });

  document.querySelectorAll('.cart').forEach(icon => {
    icon.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      openCartDrawer();
      return false;
    });
  });
});
